var START = 0,
    STEP = 1;

var range = function range() {
  var b,
      c,
      d,
      e,
      f,
      g = [];
  if (2 < arguments.length ? (b = arguments.length <= 0 ? undefined : arguments[0], c = arguments.length <= 1 ? undefined : arguments[1], d = arguments.length <= 2 ? undefined : arguments[2]) : 1 === arguments.length ? (b = START, c = arguments.length <= 0 ? undefined : arguments[0], d = STEP) : (b = arguments.length <= 0 ? undefined : arguments[0], c = arguments.length <= 1 ? undefined : arguments[1], d = STEP), e = Math.floor(Math.max(0, Math.ceil((c - b) / d))), isFinite(e)) for (f = 0; f < e; ++f) {
    g.push(d * f + b);
  }
  return g;
};

export default range;